import { useState } from 'react';
import {
  Box,
  Button,
  Divider,
  Paper,
  Typography,
} from '@material-ui/core';

import { NutritionistSearchTest } from 'features/nutritionists/components/nutritionist-search-test/nutritionist-search-test.component';
import { NutritionistSearchFilter } from 'features/nutritionists/components/nutritionist-search-filter/nutritionist-search-filter.component';

import { useStyles } from './nutritionist-finder.styles';

export const NutritionistFinder = () => {
  const [isTestActive, setIsTestActive] = useState(false);

  const classes = useStyles();

  const onOpenTestHandler = () => {
    setIsTestActive(true);
  };

  return (
    <Paper classes={{ root: classes.paper }} elevation={2}>
      {isTestActive && <NutritionistSearchTest />}

      {!isTestActive && (
        <Box className={classes.stack}>
          <Box component="section">
            <NutritionistSearchFilter />
          </Box>

          <Divider />

          <Box component="section" className={classes.stackMd}>
            <Typography variant="body2" align="center">
              ¿No sabes por donde iniciar? Nosotros te guiamos en tu búsqueda
            </Typography>
            <Box textAlign="center">
              <Button
                variant="contained"
                color="primary"
                onClick={onOpenTestHandler}
              >
                Toma el Wellnub Test
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Paper>
  );
};
